export type EtikettField =
  | 'articleName'
  | 'featured'
  | 'description'
  | 'japan'
  | 'ingredients'
  | 'nutrients'
  | 'mhd'
  | 'charge'
  | 'weight'
  | 'color'
  | 'bio'
  | 'fairtrade'
  | 'allergen'
  | 'expandedIngredients'
  | 'ingredientsOnOtherLabel'
  | 'fontSize'
  | 'eanBarcode';

const OWN_BRAND_DOSE: EtikettField[] = [
  'articleName', 'featured', 'description', 'japan', 'ingredients', 'nutrients',
  'mhd', 'charge', 'weight', 'color', 'bio', 'fairtrade', 'allergen',
  'expandedIngredients', 'ingredientsOnOtherLabel', 'fontSize',
];

const OWN_BRAND_STRIP: EtikettField[] = [
  'articleName', 'featured', 'description', 'ingredients', 'mhd', 'charge',
  'weight', 'color', 'bio', 'fairtrade', 'allergen', 'fontSize',
];

const OWN_BRAND_COMPACT: EtikettField[] = [
  'articleName', 'featured', 'description', 'ingredients', 'mhd', 'charge',
  'weight', 'color', 'bio', 'allergen', 'fontSize',
];

const ARTICLE_ROUND: EtikettField[] = [
  'articleName', 'ingredients', 'nutrients', 'mhd', 'charge', 'eanBarcode', 'bio',
];

const FAMILY_FIELDS: Record<string, EtikettField[]> = {
  F1: OWN_BRAND_DOSE,
  'F1-new': OWN_BRAND_DOSE,
  F2: OWN_BRAND_DOSE,
  F3: OWN_BRAND_STRIP,
  F4: OWN_BRAND_COMPACT,
  F5: [...OWN_BRAND_COMPACT, 'eanBarcode'],
  F6: OWN_BRAND_COMPACT,
  F7: ['ingredients', 'mhd', 'charge', 'bio', 'allergen'],
  F8: ['eanBarcode'],
  F9: ['ingredients', 'mhd', 'charge', 'eanBarcode', 'bio'],
  F10: ARTICLE_ROUND,
  F11: ARTICLE_ROUND,
  F12: ['articleName'],
  F13: ['articleName', 'eanBarcode'],
  F14: ['articleName', 'ingredients', 'nutrients', 'mhd', 'charge', 'eanBarcode', 'bio'],
};

export function familyHasField(family: string | undefined, field: EtikettField): boolean {
  if (!family) {
    return false;
  }
  return (FAMILY_FIELDS[family] ?? []).includes(field);
}
